import {AccordionData} from "../../../global/interfaces/AccordionData";
import {Change} from "../../../global/interfaces/Change";
import {createChangeFromAccordionData} from "./CreateChangeFromAccordionData";


const getAccordionDataChanges = (originalArray: AccordionData[], stateArray: AccordionData[], suchname: string): Change[] => {

    let changes: Change[] = []

    stateArray.forEach((field, index) => {
        if (field.value !== originalArray[index].value) {
            const change = createChangeFromAccordionData(originalArray[index], field, suchname, "")
            changes.push({...change})
        }
    })

    return changes;
}

export default getAccordionDataChanges;